import NextImage from 'next/image'
import { Images, Routes } from '@/assets/configs'
import { EmtSimpleLayout, EmtSimpleLayoutProps } from 'emt-components-v2'
import NextALink from '@/components/NextALink'
import { useIsQueryOwner, useIsResponsive } from '@/hooks'
import { usePetsittingMode } from '@/store/usePetsittingMode'

import VariantImages from '@/assets/VariantImages'

type Props = Omit<EmtSimpleLayoutProps, 'logo' | 'topBackground'> & {
  className?: string
}

const SimpleLayout: React.FC<Props> = ({ pro, maxWidth, children, goBack, className, ...props }) => {
  const [, type, appendQueryType] = useIsQueryOwner(true)
  const { sx, ...rest } = props
  const [isMobile] = useIsResponsive()
  const { isPetsittingMode } = usePetsittingMode()

  const logo = (
    <NextALink href={type === 'pro' || pro ? appendQueryType(Routes.Pro.Dashboard) : appendQueryType(Routes.Home)}>
      <NextImage
        src={type === 'pro' || pro || isPetsittingMode ? VariantImages.LogoSitterWhiteFull : VariantImages.Logo}
        quality={100}
        alt={'Site logo'}
        style={{
          maxWidth: isMobile ? 122 : '190px',
          height: 'auto',
        }}
      />
    </NextALink>
  )

  return (
    <EmtSimpleLayout
      {...rest}
      className={className}
      logo={logo}
      topBackground={Images.Header.Pattern}
      sx={{ backgroundRepeat: 'repeat-x', paddingTop: isMobile ? '30px' : '40px', ...sx }}
      pro={type === 'pro' || pro || isPetsittingMode}
      maxWidth={maxWidth}
      goBack={goBack}
    >
      {children}
    </EmtSimpleLayout>
  )
}

export default SimpleLayout
